module.exports = __webpack_public_path__ + "static/media/contact_img.e4f421c5.png";